import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

/**
 * 管理者専用のProtectedRouteコンポーネント
 * 管理者権限を持つユーザーのみがアクセスできる
 */
const AdminProtectedRoute = ({ children }) => {
  const { currentUser, isAuthenticated } = useAuth();
  const isAdmin = currentUser?.role === 'admin' || currentUser?.role === 'privileged';

  // 未認証の場合はログインページにリダイレクト
  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }
  
  // 管理者権限がない場合はダッシュボードにリダイレクト
  if (!isAdmin) {
    return <Navigate to="/dashboard" />;
  }

  // 管理者権限がある場合は子コンポーネントを表示
  return children;
};

export default AdminProtectedRoute;